import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { isWeiXin } from '../../utils';
import { loadScript } from '@baidu/map-fe-utils';
let mapEntity = null;
let iconUid = '';
let isFirstInit = false;
/* global BMap */
export default {
  props: {
    mapOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    mapCenter: {
      type: Object,
      default() {
        return {};
      }
    },
    isMapFeedFinished: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (isWeiXin()) {
      loadScript('https://map.baidu.com/api/js?version=1.0&t=20200720528', {
        globals: 'BMap'
      }).then(() => {
        this.$nextTick(() => {
          this.initMap();
        });
      });
    }
  },
  methods: {
    initMap() {
      const $el = this.$refs.mapContainer;
      const map = new BMap.Map($el, this.mapOptions);
      mapEntity = map;
      this.mapInitClick();
      const {
        x = '',
        y = ''
      } = this.mapCenter || {};
      const center = new BMap.Point(x, y);
      map.centerAndZoom(center, 18);
      map.enableScrollWheelZoom(true);
      isFirstInit = true;
      this.addOverlay(center);
    },
    mapInitClick() {
      mapEntity.addEventListener('click', e => {
        if (!this.isMapFeedFinished) {
          return;
        }
        const {
          icon = {}
        } = e;
        if (icon && icon.uid !== iconUid) {
          iconUid = icon.uid;
          isFirstInit = false;
          this.addOverlay(e.point, icon);
        }
      });
    },
    addOverlay(point, data = {}) {
      if (!mapEntity) {
        return;
      }
      mapEntity.clearOverlays();
      const overlay = new BMap.Marker(point);
      mapEntity.addOverlay(overlay);
      if (!isFirstInit) {
        const res = mapEntity.getBounds();
        const overlayObj = _objectSpread(_objectSpread(_objectSpread({}, overlay), res), {}, {
          pointObj: data
        });
        this.$emit('overlay-add', overlayObj);
      }
      return overlay;
    }
  }
};